import React from "react";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import Header from "./header";
import Body from "./body";

const SummaryScreen = (props) => {
    const {
        evaluatedName,
        isLoading,
        summaryData,
        process,
        handleOpenViewFeedback,
        handleClose,
        level,
        subtitle,
    } = props;

    const color = useSelector(getAppColor);

    const goBackButton = () => (
        <CustomIconButton title={getLocalizedString("goBack")} onClick={handleClose} type={"goBack"} />
    );

    const subtitleElement = () => (
        <>
            <Typography style={{ fontSize: "1rem", fontWeight: 700 }} variant="h6" id="toolbar-title">
                {subtitle}
            </Typography>
        </>
    );

    return (
        <CommonPage
            isNotGridPage
            isLoading={isLoading}
            title={getLocalizedString("performanceSummaryAndResults")}
            customHeader={subtitleElement}
            menuItems={[goBackButton]}
        >
            <Grid container item xs={12} style={{ margin: "-15px 25px 0px 25px" }}>
                <Header
                    color={color}
                    evaluatedName={evaluatedName}
                    summaryData={summaryData}
                    process={process}
                    level={level}
                />
                <Body
                    level={level}
                    color={color}
                    process={process}
                    summaryData={summaryData}
                    handleOpenViewFeedback={handleOpenViewFeedback}
                />
            </Grid>
        </CommonPage>
    );
};

export default SummaryScreen;
